import { LockType } from '../data/lockType';

export const XFA_CALL_DOWN_LOCK_TYPES: readonly LockType[] = [
  LockType.XFAACTIVATIONCALLDOWN,
  LockType.STXFA,
  LockType.PROACCOUNT,
];

export const isXfaCallDownLockType = (lockType?: string | null): boolean => {
  return XFA_CALL_DOWN_LOCK_TYPES.includes(lockType as LockType);
};

export const isXfaActivationLockType = (lockType?: string | null): boolean => {
  return lockType === LockType.XFAACTIVATION || isXfaCallDownLockType(lockType);
};

export const isIdvHoldLockType = (lockType?: string | null): boolean => {
  return [LockType.KYCHOLD, LockType.IDVHOLDAUTO].includes(lockType as LockType);
};

export const isDllRequiredLockType = (lockType?: string | null): boolean => {
  return [LockType.DLLREQUIRED, LockType.RTP].includes(lockType as LockType);
};

// Lock types that block general purchases. Mirrors the backend lock policy
// (the lock types whose `doesLockTypeBlockAction(lockType, PURCHASE)` is true) so
// the UI never lets a trader reach a purchase step the backend will reject.
export const isPurchaseBlockedLockType = (lockType?: string | null): boolean => {
  return [
    LockType.FULL,
    LockType.PURCHASE,
    LockType.PROFILEDELETION,
    LockType.KYCHOLD,
    LockType.IDVHOLDAUTO,
    LockType.UNDERAGE,
    LockType.PRTF,
    LockType.RTPMPU,
    LockType.REGIONS,
    LockType.OTHER,
    LockType.EXCESSIVECHARGEBACK,
  ].includes(lockType as LockType);
};

// Lock types that block payout requests. Mirrors the backend lock policy
// (the lock types whose `doesLockTypeBlockAction(lockType, PAYOUT)` is true) so
// the UI never lets a trader reach a payout step the backend will reject.
export const isPayoutBlockedLockType = (lockType?: string | null): boolean => {
  return [
    LockType.FULL,
    LockType.PAYOUT,
    LockType.PURCHASE,
    LockType.PROFILEDELETION,
    LockType.KYCHOLD,
    LockType.IDVHOLDAUTO,
    LockType.UNDERAGE,
    LockType.PRTF,
    LockType.RTPMPU,
    LockType.REGIONS,
    LockType.EXCESSIVECHARGEBACK,
    LockType.ATO,
  ].includes(lockType as LockType);
};
